import { Component, ElementRef, OnDestroy, computed, effect, signal, viewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import ApexCharts, { type ApexOptions } from 'apexcharts';
import { BreadcrumbComponent } from '../../../../shared/components/breadcrumb/breadcrumb.component';
import { LucideModule } from '../../../../shared/modules/lucide.module';

export interface ManifestacaoEstatistica {
  cod_situacao_sit: number;
  dat_inicio_tso?: string;
  dat_fim_sos?: string;
  dat_prazo_final_tso?: string;
  des_titulo_solicitacao_sol?: string;
  quantidade_dias?: number;
}

export interface DadosGraficoOuvidoria {
  denuncia: number;
  reclamacao: number;
  elogio: number;
  sugestao: number;
  solicitacao: number;
}

const SITUACAO_RESPONDIDA = 6;

const SITUACAO_CANCELADA = 29;

const TIPOS: readonly { label: string; value: number }[] = [
  { label: 'Denúncia', value: 4 },
  { label: 'Reclamação', value: 5 },
  { label: 'Solicitação', value: 6 },
  { label: 'Sugestão', value: 7 },
  { label: 'Elogio', value: 9 },
];

const DADOS: readonly ManifestacaoEstatistica[] = [
  { cod_situacao_sit: 6, dat_inicio_tso: '2026-01-08', dat_fim_sos: '2026-01-18', dat_prazo_final_tso: '2026-01-28', des_titulo_solicitacao_sol: 'Falta de médico na unidade de saúde', quantidade_dias: 10 },
  { cod_situacao_sit: 6, dat_inicio_tso: '2026-01-14', dat_fim_sos: '2026-02-02', dat_prazo_final_tso: '2026-01-30', des_titulo_solicitacao_sol: 'Demora no atendimento de saúde', quantidade_dias: -3 },
  { cod_situacao_sit: 1, dat_inicio_tso: '2026-01-22', dat_prazo_final_tso: '2026-02-11', des_titulo_solicitacao_sol: 'Transporte escolar irregular', quantidade_dias: 6 },
  { cod_situacao_sit: 6, dat_inicio_tso: '2026-02-03', dat_fim_sos: '2026-02-12', dat_prazo_final_tso: '2026-02-23', des_titulo_solicitacao_sol: 'Vaga em creche — educação infantil', quantidade_dias: 11 },
  { cod_situacao_sit: 6, dat_inicio_tso: '2026-02-09', dat_fim_sos: '2026-02-20', dat_prazo_final_tso: '2026-03-01', des_titulo_solicitacao_sol: 'Elogio à equipe de educação', quantidade_dias: 9 },
  { cod_situacao_sit: 2, dat_inicio_tso: '2026-02-17', dat_prazo_final_tso: '2026-03-09', des_titulo_solicitacao_sol: 'Ponto de transporte sem cobertura', quantidade_dias: -4 },
  { cod_situacao_sit: 6, dat_inicio_tso: '2026-03-02', dat_fim_sos: '2026-03-10', dat_prazo_final_tso: '2026-03-22', des_titulo_solicitacao_sol: 'Iluminação e segurança na praça', quantidade_dias: 12 },
  { cod_situacao_sit: 1, dat_inicio_tso: '2026-03-11', dat_prazo_final_tso: '2026-03-31', des_titulo_solicitacao_sol: 'Revisão de imposto predial', quantidade_dias: 8 },
  { cod_situacao_sit: 6, dat_inicio_tso: '2026-03-19', dat_fim_sos: '2026-03-27', dat_prazo_final_tso: '2026-04-08', des_titulo_solicitacao_sol: 'Cobrança indevida de tributo', quantidade_dias: 12 },
  { cod_situacao_sit: 6, dat_inicio_tso: '2026-04-06', dat_fim_sos: '2026-04-15', dat_prazo_final_tso: '2026-04-26', des_titulo_solicitacao_sol: 'Sugestão de melhoria no transporte', quantidade_dias: 11 },
  { cod_situacao_sit: 3, dat_inicio_tso: '2026-04-13', dat_prazo_final_tso: '2026-05-03', des_titulo_solicitacao_sol: 'Segurança no entorno da escola', quantidade_dias: 3 },
  { cod_situacao_sit: 6, dat_inicio_tso: '2026-04-21', dat_fim_sos: '2026-05-06', dat_prazo_final_tso: '2026-05-11', des_titulo_solicitacao_sol: 'Atendimento na unidade de saúde', quantidade_dias: 5 },
  { cod_situacao_sit: 6, dat_inicio_tso: '2026-05-05', dat_fim_sos: '2026-05-14', dat_prazo_final_tso: '2026-05-25', des_titulo_solicitacao_sol: 'Limpeza urbana no bairro', quantidade_dias: 11 },
  { cod_situacao_sit: 1, dat_inicio_tso: '2026-05-18', dat_prazo_final_tso: '2026-06-07', des_titulo_solicitacao_sol: 'Buraco na via — mobilidade', quantidade_dias: -2 },
  { cod_situacao_sit: 6, dat_inicio_tso: '2026-06-02', dat_fim_sos: '2026-06-11', dat_prazo_final_tso: '2026-06-22', des_titulo_solicitacao_sol: 'Elogio ao serviço de saúde', quantidade_dias: 11 },
  { cod_situacao_sit: 29, dat_inicio_tso: '2026-06-15', des_titulo_solicitacao_sol: 'Manifestação cancelada pelo cidadão' },
  { cod_situacao_sit: 2, dat_inicio_tso: '2026-06-24', dat_prazo_final_tso: '2026-07-14', des_titulo_solicitacao_sol: 'Educação — material didático', quantidade_dias: 5 },
  { cod_situacao_sit: 6, dat_inicio_tso: '2026-07-06', dat_fim_sos: '2026-07-16', dat_prazo_final_tso: '2026-07-26', des_titulo_solicitacao_sol: 'Transporte público lotado', quantidade_dias: 10 },
];

const DADOS_GRAFICO: DadosGraficoOuvidoria = {
  denuncia: 4,
  reclamacao: 6,
  elogio: 3,
  sugestao: 2,
  solicitacao: 3,
};

const TEMPO_MEDIO_RESPOSTA = 10;

const PRAZO_RESPOSTA = 20;

@Component({
  selector: 'app-estatisticas-ouvidoria',
  templateUrl: './estatisticas-ouvidoria.component.html',
  styleUrls: ['./estatisticas-ouvidoria.component.css'],
  imports: [BreadcrumbComponent, FormsModule, LucideModule],
})
export class EstatisticasOuvidoriaComponent implements OnDestroy {
  readonly tipos = TIPOS;

  readonly dataInicio = signal('');
  readonly dataFim = signal('');
  readonly tipoSelecionado = signal<number | ''>('');

  readonly dados = signal<readonly ManifestacaoEstatistica[]>(DADOS);
  readonly dadosGrafico = signal<DadosGraficoOuvidoria>(DADOS_GRAFICO);
  readonly tempoMedioResposta = signal<number | null>(TEMPO_MEDIO_RESPOSTA);
  readonly prazoResposta = signal<number | null>(PRAZO_RESPOSTA);

  private readonly elTipoManifestacoes = viewChild.required<ElementRef<HTMLElement>>('graficoTipoManifestacoes');
  private readonly elAssuntos = viewChild.required<ElementRef<HTMLElement>>('graficoAssuntos');
  private readonly elTendenciaMensal = viewChild.required<ElementRef<HTMLElement>>('graficoTendenciaMensal');

  private chartTipoManifestacoes: ApexCharts | null = null;
  private chartAssuntos: ApexCharts | null = null;
  private chartTendenciaMensal: ApexCharts | null = null;

  readonly manifestacoesRespondidas = computed(
    () => this.dados().filter((item) => item.cod_situacao_sit === SITUACAO_RESPONDIDA).length,
  );

  readonly manifestacoesNaoRespondidas = computed(() =>
    this.dados().filter(
      (item) => item.cod_situacao_sit !== SITUACAO_RESPONDIDA && item.cod_situacao_sit !== SITUACAO_CANCELADA,
    ),
  );

  readonly manifestacoesNoPrazo = computed(
    () =>
      this.dados().filter(
        (item) =>
          item.cod_situacao_sit === SITUACAO_RESPONDIDA &&
          item.dat_fim_sos &&
          item.dat_prazo_final_tso &&
          new Date(item.dat_fim_sos) <= new Date(item.dat_prazo_final_tso),
      ).length,
  );

  readonly manifestacoesNaoRespondidasEmAtraso = computed(
    () =>
      this.manifestacoesNaoRespondidas().filter(
        (item) => item.quantidade_dias !== undefined && item.quantidade_dias <= 0,
      ).length,
  );

  readonly manifestacoesNaoRespondidasNoPrazo = computed(
    () =>
      this.manifestacoesNaoRespondidas().filter(
        (item) => item.quantidade_dias !== undefined && item.quantidade_dias >= 0,
      ).length,
  );

  readonly percentualNaoRespondidasNoPrazo = computed(() =>
    this.percentual(this.manifestacoesNaoRespondidasNoPrazo(), this.manifestacoesNaoRespondidas().length),
  );

  readonly percentualNoPrazo = computed(() =>
    this.percentual(this.manifestacoesNoPrazo(), this.manifestacoesRespondidas()),
  );

  readonly percentualRespondidas = computed(() =>
    this.percentual(this.manifestacoesRespondidas(), this.dados().length),
  );

  constructor() {
    effect(() => this.renderizarGraficoTipoManifestacoes());
    effect(() => this.renderizarGraficoAssuntos());
    effect(() => this.renderizarGraficoTendenciaMensal());
  }

  ngOnDestroy(): void {
    this.chartTipoManifestacoes?.destroy();
    this.chartAssuntos?.destroy();
    this.chartTendenciaMensal?.destroy();
  }

  getPercentual(valor: number): number {
    const grafico = this.dadosGrafico();

    const total =
      Number(grafico.denuncia ?? 0) +
      Number(grafico.reclamacao ?? 0) +
      Number(grafico.solicitacao ?? 0) +
      Number(grafico.sugestao ?? 0) +
      Number(grafico.elogio ?? 0);

    if (total === 0) return 0;

    return (valor / total) * 100;
  }

  aplicarFiltros(): void {
  }

  limparFiltros(): void {
    this.dataInicio.set('');
    this.dataFim.set('');
    this.tipoSelecionado.set('');

    this.aplicarFiltros();
  }

  private percentual(parte: number, total: number): number {
    if (total <= 0) return 0;

    return parseFloat(((parte / total) * 100).toFixed(2));
  }

  private renderizarGraficoTipoManifestacoes(): void {
    const grafico = this.dadosGrafico();

    const valores = {
      denuncia: Number(grafico.denuncia ?? 0),
      reclamacao: Number(grafico.reclamacao ?? 0),
      elogio: Number(grafico.elogio ?? 0),
      sugestao: Number(grafico.sugestao ?? 0),
      solicitacao: Number(grafico.solicitacao ?? 0),
    };

    const total =
      valores.denuncia + valores.reclamacao + valores.elogio + valores.sugestao + valores.solicitacao;

    const porcentagens =
      total > 0
        ? [
            (valores.denuncia / total) * 100,
            (valores.reclamacao / total) * 100,
            (valores.elogio / total) * 100,
            (valores.sugestao / total) * 100,
            (valores.solicitacao / total) * 100,
          ]
        : [0, 0, 0, 0, 0];

    this.chartTipoManifestacoes?.destroy();

    const options: ApexOptions = {
      chart: {
        type: 'bar',
        height: 350,
        toolbar: { show: false },
      },
      xaxis: {
        categories: ['Denúncias', 'Reclamações', 'Elogios', 'Sugestão', 'Solicitação'],
        labels: {
          style: {
            fontSize: '14px',
            fontWeight: 500,
            colors: '#2c3e50',
          },
        },
      },
      yaxis: {
        max: 100,
        labels: {
          formatter: (val: number) => `${val.toFixed(0)}%`,
          style: {
            fontSize: '12px',
            colors: '#7f8c8d',
          },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: (val: number) => `${val.toFixed(1)}%`,
        style: {
          colors: ['#ffffff'],
          fontSize: '14px',
          fontWeight: 600,
        },
        offsetY: 5,
      },
      plotOptions: {
        bar: {
          columnWidth: '45%',
          borderRadius: 4,
          distributed: false,
          dataLabels: {
            position: 'top',
          },
        },
      },
      colors: ['var(--primary-dark)'],
      series: [
        {
          name: 'Porcentagem',
          data: porcentagens,
        },
      ],
      grid: {
        borderColor: '#ecf0f1',
        strokeDashArray: 5,
      },
      tooltip: {
        y: {
          formatter: (val: number) => `${val.toFixed(2)}%`,
        },
      },
    };

    this.chartTipoManifestacoes = new ApexCharts(this.elTipoManifestacoes().nativeElement, options);
    this.chartTipoManifestacoes.render();
  }

  private renderizarGraficoAssuntos(): void {
    const assuntos: Record<string, number> = {};

    for (const item of this.dados()) {
      const titulo = item.des_titulo_solicitacao_sol?.toLowerCase() ?? '';

      if (titulo.includes('saúde')) {
        assuntos['Saúde'] = (assuntos['Saúde'] || 0) + 1;
      } else if (titulo.includes('educação')) {
        assuntos['Educação'] = (assuntos['Educação'] || 0) + 1;
      } else if (titulo.includes('transporte')) {
        assuntos['Transporte'] = (assuntos['Transporte'] || 0) + 1;
      } else if (titulo.includes('segurança')) {
        assuntos['Segurança'] = (assuntos['Segurança'] || 0) + 1;
      } else if (titulo.includes('imposto') || titulo.includes('tributo')) {
        assuntos['Tributação'] = (assuntos['Tributação'] || 0) + 1;
      } else {
        assuntos['Outros'] = (assuntos['Outros'] || 0) + 1;
      }
    }

    const topAssuntos = Object.entries(assuntos)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 10);

    const labels = topAssuntos.map((item) => item[0]);
    const valores = topAssuntos.map((item) => item[1]);

    this.chartAssuntos?.destroy();

    const options: ApexOptions = {
      chart: {
        type: 'bar',
        height: 350,
        toolbar: { show: false },
      },
      plotOptions: {
        bar: {
          horizontal: true,
          borderRadius: 4,
        },
      },
      series: [
        {
          name: 'Manifestações',
          data: valores,
        },
      ],
      xaxis: {
        categories: labels,
        labels: {
          style: {
            fontSize: '13px',
          },
        },
      },
      colors: ['#8884D8'],
      dataLabels: {
        enabled: true,
      },
      grid: {
        borderColor: '#E5E5E5',
        strokeDashArray: 4,
      },
      legend: {
        show: false,
      },
    };

    this.chartAssuntos = new ApexCharts(this.elAssuntos().nativeElement, options);
    this.chartAssuntos.render();
  }

  private renderizarGraficoTendenciaMensal(): void {
    const agrupadoPorMes: Record<
      string,
      { label: string; recebidas: number; respondidas: number; noPrazo: number }
    > = {};

    for (const item of this.dados()) {
      const referencia = item.dat_inicio_tso ?? item.dat_fim_sos;
      if (!referencia) continue;

      const data = new Date(referencia);

      const key = `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, '0')}`;
      const label = data.toLocaleDateString('pt-BR', { month: 'short', year: 'numeric' });

      agrupadoPorMes[key] ??= { label, recebidas: 0, respondidas: 0, noPrazo: 0 };
      agrupadoPorMes[key].recebidas += 1;

      if (item.cod_situacao_sit === SITUACAO_RESPONDIDA) {
        agrupadoPorMes[key].respondidas += 1;

        if (item.dat_fim_sos && item.dat_prazo_final_tso) {
          const fim = new Date(item.dat_fim_sos);
          const prazo = new Date(item.dat_prazo_final_tso);

          if (fim <= prazo) {
            agrupadoPorMes[key].noPrazo += 1;
          }
        }
      }
    }

    const chavesOrdenadas = Object.keys(agrupadoPorMes).sort();

    const categorias = chavesOrdenadas.map((key) => agrupadoPorMes[key].label);
    const recebidas = chavesOrdenadas.map((key) => agrupadoPorMes[key].recebidas);
    const respondidas = chavesOrdenadas.map((key) => agrupadoPorMes[key].respondidas);
    const noPrazo = chavesOrdenadas.map((key) => agrupadoPorMes[key].noPrazo);

    this.chartTendenciaMensal?.destroy();

    const options: ApexOptions = {
      chart: {
        type: 'line',
        height: 350,
        toolbar: { show: false },
      },
      xaxis: {
        categories: categorias,
        labels: {
          style: { fontSize: '13px' },
        },
      },
      series: [
        { name: 'Recebidas', data: recebidas },
        { name: 'Respondidas', data: respondidas },
        { name: 'No Prazo', data: noPrazo },
      ],
      yaxis: {
        min: 0,
        forceNiceScale: true,
        labels: {
          style: { fontSize: '13px' },
        },
      },
      stroke: {
        curve: 'smooth',
        width: 3,
        dashArray: [0, 5, 5],
      },
      markers: {
        size: 5,
        strokeWidth: 2,
        hover: { size: 7 },
      },
      colors: ['#928FDB', '#C0E4CE', '#FFD484'],
      legend: {
        show: true,
        position: 'bottom',
        fontSize: '14px',
        fontWeight: 500,
        markers: { size: 6, shape: 'circle' },
        itemMargin: { horizontal: 12, vertical: 8 },
      },
      dataLabels: { enabled: false },
      grid: {
        borderColor: '#E5E5E5',
        strokeDashArray: 5,
      },
    };

    this.chartTendenciaMensal = new ApexCharts(this.elTendenciaMensal().nativeElement, options);
    this.chartTendenciaMensal.render();
  }
}
